import buildConfig from '../utils/build-config'
import { ApiActionConfig } from './types'

// TODO: Figure out how to specify `RootState` and `SupportedAction` instead of having `any`.
const { getConfig, setConfig } = buildConfig<ApiActionConfig<any, any>>('api-action')

export { setConfig as configureApiAction }

export default getConfig
